import { parseJwt } from "./auth";

export const portalDistribuidor = () => {
  if (process.env.REACT_APP_PORTAL === "distribuidor") return true;
  if (typeof window === "undefined") return false;
  if (window.location.hostname.toLowerCase().includes("distribuidor")) return true;
  const token = sessionStorage.getItem("token");
  const tipo = parseJwt(token)?.Tipo || parseJwt(token)?.tipo || sessionStorage.getItem("portalTipo");
  return String(tipo || "").toLowerCase() === "distribuidor";
};
